import { useQuery } from '@tanstack/react-query';
import {
  fetchDeployedAppVersion,
  isAppUpdateAvailable,
} from '@/helpers/appVersion';

const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const FOCUS_CHECK_STALE_MS = 60 * 1000;

export const useAvailableAppUpdate = (): string | null => {
  const runningVersion = import.meta.env.VITE_APP_VERSION;

  const { data: deployedVersion } = useQuery({
    queryKey: ['deployedAppVersion'],
    queryFn: fetchDeployedAppVersion,
    enabled: !!runningVersion,
    refetchInterval: CHECK_INTERVAL_MS,
    refetchOnWindowFocus: true,
    staleTime: FOCUS_CHECK_STALE_MS,
  });

  return isAppUpdateAvailable(runningVersion, deployedVersion)
    ? deployedVersion
    : null;
};
